import * as React from 'react'
import { IMessage } from 'static/interfaces'
import styled from 'styled-components'
import * as constants from '../../../../../static/constants'
import { withHtmlTag } from '../../../../../utils'

interface IProps {
  message: IMessage
  isGuide: boolean
  onUpdate?: () => void
}

const MessageBalloon: React.FC<IProps> = props => {
  const { message } = props
  return (
    <Message key={message.id} className={message.isSelf ? 'self' : 'other'}>
      {!message.isSelf && (
        <div className="Message_Sender">
          <div className="Message_Avator">
            <img src={message.sender.avatar_url} alt="" loading="lazy" />
          </div>
          <div className="Message_Sender_Username">{message.sender.username}</div>
        </div>
      )}
      <div className="Message_Balloon">
        <div>
          {message.file_attached && (
            <div className="Message_Image">
              <img src={message.file_url} alt="" loading="lazy" />
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: withHtmlTag(message.body) }} />
        </div>
      </div>
      <div className="Message_Time">{message.sent_at}</div>
    </Message>
  )
}

const Message = styled.div`
  .Message_Sender {
    display: flex;
    margin-bottom: 4px;
  }

  .Message_Avator {
    flex: none;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 40px;
      height: 40px;
    }

    > img {
      width: inherit;
      height: inherit;
      object-fit: cover;
    }
  }

  .Message_Sender_Username {
    align-self: center;
    margin-left: 0.7rem;
  }

  .Message_Balloon {
    min-width: 50%;
    max-width: 80%;
    background-color: white;
    padding: 8px 16px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 12px;
    word-break: break-word;
    white-space: pre-line;
  }

  .Message_Image {
    max-width: 360px;

    > img {
      width: 100%;
      height: auto;
    }
  }

  .Message_Time {
    font-size: 12px;
    margin-top: 4px;
  }

  &.other {
    .Message_Balloon {
      margin-left: 3.5rem;
      margin-right: auto;
    }
    .Message_Time {
      margin-left: 3.5rem;
    }
  }

  &.self {
    .Message_Balloon {
      margin-left: auto;
      background-color: ${constants.COLORS.successBG};
    }

    .Message_Time {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 4px;
    }
  }

  & + & {
    margin-top: 24px;
  }
`
export default MessageBalloon
